<template>
  <div id="search">
    <input
      type="text"
      id="searchBox"
      v-model="searchInput"
      @keyup="handleSearch"
      placeholder="Search for users..."
    />
    <ion-icon name="ios-search"></ion-icon>
    <ion-icon v-if="showClear" name="close-circle-outline" @click="clearInput"></ion-icon>
  </div>
</template>

<script>
import algoliaSearch from "algoliasearch/lite";

export default {
  data() {
    return {
      searchClient: algoliaSearch(
        "HU4XMG2UTE",
        "bc3645b95de77400a5d1053b0a97d946"
      ),
      searchInput: "",
      showClear: false,
      showLoader: false,
      counter: 0
    };
  },
  methods: {
    debounceHandleSearch() {
      let timer;
      let _this = this;

      return () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          _this.handleSearch();
        }, 300);
      };
    },
    handleSearch() {
      this.mobileSearchActive();

      if (this.searchInput !== "") {
        let tempPayload = {};
        tempPayload.showLoader = true;
        tempPayload.width = "100%";
        this.$store.dispatch("updateAlgoliaObject", tempPayload);
      }

      setTimeout(() => {
        const index = this.searchClient.initIndex("users");

        index.search(
          {
            query: this.searchInput,
            attributesToRetrieve: [
              "firstName",
              "lastName",
              "username",
              "photoURL",
              "deleted"
            ]
          },
          (err, { hits } = {}) => {
            if (err) throw err;

            let payload = {};

            if (this.searchInput === "") {
              payload.data = [];
              payload.noResults = false;
              payload.showLoader = false;
              this.$store.dispatch("updateAlgoliaObject", payload);
              this.$store.dispatch("updateMobileSearch", false);
              this.showClear = false;
            } else {
              if (hits.length === 0) {
                payload.data = [];
                payload.width = "100%";
                payload.noResults = true;
                payload.showLoader = false;
                this.$store.dispatch("updateAlgoliaObject", payload);
                this.showClear = true;
              } else {
                //Filter out users with bad IDs
                let correctIDs = hits.filter(item => item.objectID.length > 20);
                payload.data = correctIDs;
                payload.width = "100%";
                payload.noResults = correctIDs.length > 0 ? false : true;
                payload.showLoader = false;
                this.$store.dispatch("updateAlgoliaObject", payload);
                this.showClear = true;
              }
            }
          }
        );
      }, 500);
    },
    clearInput() {
      this.searchInput = "";
      this.handleSearch();
    },
    mobileSearchActive() {
      if (window.outerWidth <= 768) {
        this.$store.dispatch("updateMobileSearch", true);
      } else {
        this.$store.dispatch("updateMobileSearch", false);
      }
    }
  }
};
</script>

<style scoped>
#search {
  position: relative;
}

#search input {
  width: 100%;
  padding: 13px 15px 15px 45px;
  font-size: 15px;
}

#search ion-icon[name="ios-search"] {
  font-size: 20px;
  position: absolute;
  left: 15px;
  top: 15px;
}

#search ion-icon[name="close-circle-outline"] {
  font-size: 20px;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
}

ion-icon {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/search/Search.vue